import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (F90K)
// ============================================================

export interface F90K {
  f90k_01: string;           // 單號 (PK)
  f90k_02: string;           // 申請人代號
  f90k_11: string;           // 員工代號
  f90k_12: string | null;    // 申請日期
  f90k_13: string | null;    // 擬離職日
  f90k_14: string;           // 離職原因代碼
  f90k_15: string;           // 離職說明
  f90k_21: string;           // 部門代號
  f90k_22: string;           // 職稱代號
  f90k_23: string | null;    // 到職日
  f90k_56: string;           // 手續完成勾選
  f90k_61: string;           // 移交手續(主管) Y/N
  f90k_62: string;           // 主管核准人代號
  f90k_63: string | null;    // 主管核准日期
  f90k_64: string;           // 主管核准說明
  f90k_66: string;           // 移交手續(人事主管) Y/N
  f90k_67: string;           // 人事主管核准人代號
  f90k_68: string | null;    // 人事主管核准日期
  f90k_69: string;           // 人事主管確認說明
  f90k_71: string;           // 移交手續(副總) Y/N
  f90k_72: string;           // 副總核准人代號
  f90k_73: string | null;    // 副總核准日期
  f90k_74: string;           // 副總核准說明
  f90k_76: string;           // 移交手續(總經理) Y/N
  f90k_77: string;           // 總經理核准人代號
  f90k_78: string | null;    // 總經理核准日期
  f90k_79: string;           // 總經理核准說明
  f90k_80: string;           // 狀態 V=待審/P=核准/X=已離
  f90k_91: string;           // 建立者
  f90k_92: string | null;    // 建立時間
  f90k_93: string;           // 更新者
}

// ============================================================
// Request / Response types
// ============================================================

export interface P9207ListResponse {
  data: F90K[];
  total: number;
  page: number;
  size: number;
}

export interface P9207CreateRequest {
  master: Partial<F90K>;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
//離職原因選項（from spec: Combo1 rowSource）
// ============================================================
export const RESIGNATION_REASONS = [
  '環境(氣氛)不佳',
  '志趣不合',
  '健康因素',
  '結婚生育',
  '出國',
  '服役',
  '其它',
];

// ============================================================
// API methods
// ============================================================

export const p9207Api = {
  async list(page = 1, size = 20): Promise<P9207ListResponse> {
    const res = await apiClient.get('/api/p9207', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<F90K> {
    const res = await apiClient.get(`/api/p9207/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: P9207CreateRequest): Promise<F90K> {
    const res = await apiClient.post('/api/p9207', data);
    return res.data;
  },

  async update(id: string, data: P9207CreateRequest): Promise<F90K> {
    const res = await apiClient.put(`/api/p9207/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/p9207/${encodeURIComponent(id)}`);
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/p922a/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
